











import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DeployDialog from './DeployDialog.vue';
import { Deployment } from '@/types';
import Constants from '@/constants';
import { DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT } from '@/store/mutypes';

@Component({
  name: 'deploy-button',
  components: {
    DeployDialog
  }
})
export default class DeployButton extends Vue {
  @Prop({ required: true })
  deployment!: Deployment;

  get isNew() {
    return this.deployment.status === Constants.DEPLOYMENT_STATUS_NEW;
  }

  onDeployButtonClicked() {
    this.$store.commit(DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT, this.deployment);
  }
}
